module.exports = __webpack_public_path__ + "static/media/dutchgovt.c4d1918b.png";